import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import { t } from 'i18next';

interface AddModalProps {
  setOpenAddCategory: any;
  fetchHelpData: any;
}

interface Category {
  id: number;
  title: string;
  parentId: number | null;
}

const AddCategoryHelp: React.FC<AddModalProps> = ({ setOpenAddCategory, fetchHelpData }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [newCategory, setNewCategory] = useState('');
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedParentId, setSelectedParentId] = useState<number | null>(null);

  const handleClose = () => setOpenAddCategory(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get('helpdesk');
        setCategories(data);
      } catch (error) {
        enqueueSnackbar('Error loading categories', { variant: 'error' });
      }
    };

    fetchCategories();
  }, [enqueueSnackbar]);

  const parentCategories = categories.filter(
    (cat) => cat.parentId === null
  );

  const handleAddCategory = async () => {
    try {
      if (!newCategory.trim()) {
        enqueueSnackbar('Add name category', { variant: 'error' });
        return;
      }

      await axios.post('helpdesk/add', {
        title: newCategory,
        parentId: selectedParentId, 
        layout: '',
        description: '',
      });

      enqueueSnackbar('Category created', { variant: 'success' });

      setNewCategory('');
      setSelectedParentId(null);
      fetchHelpData();
      handleClose();
    } catch (error: any) {
      console.error('Error', error);
      enqueueSnackbar('Error', { variant: 'error' });
    }
  };

  return (
    <Box
      sx={{
        width: 350,
        background: 'var(--bg-form)',
        p: 2,
      }}
      role="presentation"
    >
      <List>
        <div className='text-[var(--text-color)]'>
          <h1 className='text-[20px] font-bold mb-[15px] text-right'>
            {t('AddCategory')}
          </h1>
          <hr className='hr mt-[10px] mb-[15px]' />
          <label className='text-[10px] ml-[5px]'>{t('SelectParentCategory')}:</label>
          <select
            className='edit-select p-[5px] rounded-[5px] edit-input w-full'
            value={selectedParentId ?? ''}
            onChange={(e) =>
              setSelectedParentId(
                e.target.value ? Number(e.target.value) : null
              )
            }>
            <option value="">
              No parent (Main category)
            </option>
            {parentCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.title}
              </option>
            ))}
          </select>
         <div className='flex flex-col mt-[15px]'>
            <label className='text-[10px] ml-[5px]'>{t('CategoryName')}:</label>
            <input
              className='w-full rounded-[5px] edit-input text-[16px] px-[5px] py-[4px]'
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)} />
         </div>
          <hr className='hr mb-[15px] mt-[10px]' />
          <div className='flex gap-[10px]'>
            <Button
              variant="contained"
              fullWidth
              onClick={handleAddCategory}>
              {t('Add')}
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleClose}>
              {t('Cancel')}
            </Button>
          </div>
        </div>
      </List>
    </Box>
  );
};

export default AddCategoryHelp;
